import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import index from '@/components/main/index'
import login from '@/components/main/login'
import register from '@/components/main/register'
import about from '@/components/main/about'
import faq from '@/components/main/faq'
import userCenter from '@/components/main/userCenter'
import accountCenter from '@/components/main/accountCenter'
import resetPasswordNew from '@/components/main/resetPasswordNew'
import modifyPhone from '@/components/main/modifyPhone'
import modifyEmail from '@/components/main/modifyEmail'
import modifyPayPassword from '@/components/main/modifyPayPassword'
import bankCard from '@/components/main/bankCard'
import addBankCard from '@/components/main/addBankCard'
import addUsdtCard from '@/components/main/addUsdtCard'

import myNews from '@/components/main/myNews'
import myNewsInfo from '@/components/main/myNewsInfo'
import assets from '@/components/main/assets'
import welfare from '@/components/main/welfare'


import applyagent from '@/components/main/applyagent'
import applyagentList from '@/components/main/applyagentList'
import activeInfo from '@/components/main/activeInfo'
import activeList from '@/components/main/activeList'
import app from '@/components/main/app'
import sponsor from '@/components/main/sponsor'
import vip from '@/components/main/vip'
import withdraw from '@/components/main/withdraw'
import deposit from '@/components/main/deposit'
import gamePage from '@/components/main/gamePage'
import games from '@/components/main/games'
import kefu from '@/components/main/kefu'
import hongbao from '@/components/main/hongbao'
import yaoqing from '@/components/main/yaoqing'


Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  // mode: 'history',
  mode: 'hash',

  routes: [
    {
      path: '/',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/login',
          name: 'login',
          component: login,

        }, {
          path: '/register',
          name: 'register',
          component: register,

        }, {
          path: '/about',
          name: 'about',
          component: about,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/faq',
          name: 'faq',
          component: faq,

        }, {
          path: '/userCenter',
          name: 'userCenter',
          component: userCenter,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false,//是否用缓存
            requireAuth: true,

          }
        }, {
          path: '/accountCenter',
          name: 'accountCenter',
          component: accountCenter,

        }, {
          path: '/resetPasswordNew',
          name: 'resetPasswordNew',
          component: resetPasswordNew,

        }, {
          path: '/modifyPhone',
          name: 'modifyPhone',
          component: modifyPhone,

        }, {
          path: '/modifyEmail',
          name: 'modifyEmail',
          component: modifyEmail,
          meta: {
            requireAuth: true,
          }
        }, {
          path: '/modifyPayPassword',
          name: 'modifyPayPassword',
          component: modifyPayPassword,
          meta: {
            requireAuth: true,
          }
        }, {
          path: '/bankCard',
          name: 'bankCard',
          component: bankCard,
          meta: {
            requireAuth: true,
          }
        }, {
          path: '/addBankCard',
          name: 'addBankCard',
          component: addBankCard,
          meta: {
            requireAuth: true,
          }
        },{
          path: '/addUsdtCard',
          name: 'addUsdtCard',
          component: addUsdtCard,
          meta: {
            requireAuth: true,
          }
        },
        
        
        {
          path: '/myNews',
          name: 'myNews',
          component: myNews,

        }, {
          path: '/myNewsInfo',
          name: 'myNewsInfo',
          component: myNewsInfo,

        }, {
          path: '/assets',
          name: 'assets',
          component: assets,
          meta: {
            requireAuth: true,
          }
        },
        {
          path: '/welfare',
          name: 'welfare',
          component: welfare,
          meta: {
            requireAuth: true,
          }
        },
         {
          path: '/applyagent',
          name: 'applyagent',
          component: applyagent,
          meta: {
            requireAuth: true,
          }
        }, {
          path: '/applyagentList',
          name: 'applyagentList',
          component: applyagentList,
          meta: {
            requireAuth: true,
          }
        }, {
          path: '/activeInfo',
          name: 'activeInfo',
          component: activeInfo,
      
        }, {
          path: '/activeList',
          name: 'activeList',
          component: activeList,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false,//是否用缓存

          }

        }, {
          path: '/app',
          name: 'app',
          component: app,

        }, {
          path: '/sponsor',
          name: 'sponsor',
          component: sponsor,

        }, {
          path: '/vip',
          name: 'vip',
          component: vip,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false,//是否用缓存

          }
        }, {
          path: '/deposit',
          name: 'deposit',
          component: deposit,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false,//是否用缓存
            requireAuth: true,

          }

        }, {
          path: '/withdraw',
          name: 'withdraw',
          component: withdraw,

        }, {
          path: '/gamePage',
          name: 'gamePage',
          component: gamePage,

          }, {
            path: '/games',
            name: 'games',
            component: games,
            meta: {
              keepAlive: true,//是否缓存组件
              useCatch: false,//是否用缓存
  
            }
  
          }, {
            path: '/kefu',
            name: 'kefu',
            component: kefu,
  
          },{
            path: '/hongbao',
            name: 'hongbao',
            component: hongbao,
            meta: {
              requireAuth: true,
            }
          },{
            path: '/yaoqing',
            name: 'yaoqing',
            component: yaoqing,
            meta: {
              requireAuth: true,
            }
          },
          
          
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js